import React from 'react';

type Props = {
  className?: string;
  value?: number;
  count?: number;
  productId?: string;
};

const Icon: React.FC<Props> = ({ className = '', value = 1, count = 1, productId = 'na' }: Props) => {
  let stopFillIndex = -1;
  return [...Array(count)].map((key: any, index: number) => {
    const offsetVar =
      index + 1 <= value
        ? '100%'
        : stopFillIndex === index
        ? '0%'
        : ((value - parseInt(value.toString())) * 100) / 1 + '%';
    if (offsetVar !== '100%') {
      stopFillIndex = index + 1;
    }
    return (
      <svg
        className={className}
        key={index}
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="19"
        fill="none"
        viewBox="0 0 21 19"
      >
        <defs>
          <linearGradient id={`mask${index}-${productId}`}>
            <stop offset="0%" stopColor="#F7B40A"></stop>
            <stop offset={offsetVar} stopColor="#F7B40A"></stop>
            <stop offset={offsetVar} stopColor="#FFFFFF"></stop>
          </linearGradient>
        </defs>
        <path
          strokeWidth="1"
          stroke="#F7B40A"
          fill={`url(#mask${index}-${productId})`}
          d="M4.767 19.564L6.42 12.48.923 7.718l7.241-.628L11 .41l2.836 6.68 7.24.628-5.497 4.762 1.654 7.084L11 15.803l-6.233 3.761z"
        ></path>
      </svg>
    );
  });
};

export default Icon;
